// 总表单 // 引入了表单控件以及可动态增减表单
<template>
  <el-form
    class="form-container"
    :inline="true"
    :model="formList.formModel"
    :rules="formList.formRules"
    :ref="formList.ref"
    :label-width="formList.labelWidth"
    @keyup.13.native="handleConfirm(formList.ref)"
  >
    <template v-if="formList.dynamicFirst">
      <template v-if="formList.dynamicValidateForm">
        <dynamicValidateForm
          :ref="formList.dynamicValidateForm.ref"
          :dynamicValidateForm="formList.dynamicValidateForm"
          v-on="$listeners"
          :label-width="formList.labelWidth"
          :loading="loading"
          @changeLoading="changeLoading"
        />
      </template>
      <template v-if="formList.formData">
        <FormControl
          v-for="item in formList.formData"
          :key="item.prop"
          :controlItem="item"
          :form="formList.formModel"
          v-on="$listeners"
        />
      </template>
      <slot name="Upload"></slot>
      <slot name="WarmReminder"></slot>
    </template>
    <template v-else>
      <template v-if="formList.formData">
        <FormControl
          v-for="item in formList.formData"
          :key="item.prop"
          :controlItem="item"
          :form="formList.formModel"
          v-on="$listeners"
        />
      </template>
      <template v-if="formList.dynamicValidateForm">
        <dynamicValidateForm
          :ref="formList.dynamicValidateForm.ref"
          :dynamicValidateForm="formList.dynamicValidateForm"
          v-on="$listeners"
          :label-width="formList.labelWidth"
          :loading="loading"
          @changeLoading="changeLoading"
        />
      </template>
    </template>
    <slot></slot>
    <!-- 添加图片 插槽 -->
    <slot name="photo"></slot>
    <el-form-item v-if="formList.type === 'Search'">
      <el-button
        type="primary"
        class="btn"
        @click="submitForm('dynamicValidateForm')"
        :loading="loading"
        icon="el-icon-search"
        >搜索</el-button
      >
      <el-button
        style="background: #fafafa"
        @click="resetForm(formList.ref)"
        icon="el-icon-delete"
      >
        清空</el-button
      >
      <slot></slot>
    </el-form-item>
    <el-form-item v-if="formList.type === 'Search'">
      <el-button
        type="primary"
        class="btn"
        @click="submitForm('dynamicValidateForm')"
        :loading="loading"
        icon="el-icon-search"
        >搜索</el-button
      >
      <el-button
        style="background: #fafafa"
        @click="resetForm(formList.ref)"
        icon="el-icon-delete"
        >清空</el-button
      >
      <slot></slot>
    </el-form-item>
    <div v-else-if="formList.type === 'newlyAdd'"></div>
    <!-- 插槽 name -->
    <slot v-else-if="formList.type === 'custom'" :name="formList.name"></slot>
    <div v-else class="dialogBtn">
      <el-form-item>
        <el-button
          type="primary"
          class="btn"
          @click="handleConfirm(formList.ref)"
          :loading="loading || formList.loading"
          >确认</el-button
        >
        <el-button
          style="background: #fafafa"
          @click="handleCancel(formList.ref)"
          :loading="loading || formList.loading"
          >取消</el-button
        >
        <slot></slot>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import dynamicValidateForm from "@/components/Form/dynamicValidateForm";
import FormControl from "@/components/Form/FormControl.vue";

export default {
  components: { dynamicValidateForm, FormControl },
  props: {
    formModel: {},
    //   整体表单数据结构
    formList: {
      advanced: "",
      // 表单作用
      type: "",
      // 表单指向
      ref: "",
      // 表单域标签的宽度
      labelWidth: "130px",
      // 表单校验规则
      formRules: {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ]
      },
      // 表单数据对象
      formModel: {
        phone: "",
        Company: ""
      },
      // 表单所含固定控件的数据
      formData: [
        {
          // 选择类型
          type: "Input",
          // 绑定表单
          model: "",
          // 控件名称
          label: "手机号码",
          // 控件属性名
          prop: "phone",
          // 控件子节点值
          value: [],
          // 是否可以动态增减
          isDynamic: false,
          // 控件配置
          props: {}
        }
      ],
      //可动态加减的控件数据
      dynamicValidateForm: {
        isTrue: "",
        //动态表单数据对象
        dynamicItem: [
          {
            email: "",
            genal: ""
          }
        ],
        // 动态控件的数据结构
        inputItem: [
          {
            label: "邮箱",
            prop: "email",

            // 选择类型
            type: "Input",
            // 控件子节点值
            value: [],
            // 绑定表单
            model: "",
            // 是否可以动态增减
            isDynamic: true,
            // 控件配置
            props: {}
          },
          {
            label: "性别",
            prop: "genal",
            // 选择类型
            type: "Radio",
            // 控件子节点值
            value: [
              {
                label: "男",
                prop: "man"
              },
              {
                label: "女",
                prop: "woman"
              }
            ],
            // 绑定表单
            model: "",
            // 是否可以动态增减
            isDynamic: true,
            // 控件配置
            props: {}
          }
        ]
      }
    }
  },
  data() {
    return {
      loading: false
    };
  },

  methods: {
    filterTime: time => {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      // h = h < 10 ? "0" + h : h;
      // var minute = date.getMinutes();
      // minute = minute < 10 ? "0" + minute : minute;
      // var s = date.getSeconds();
      // s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d;
      // return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    submitForm() {
      this.$emit("submitForm");
    },
    resetForm(val) {
      this.$refs[val].resetFields();
      this.$emit("resetForm");
    },
    getDetails() {
      let time = this.filterTime(this.formList.formModel.visitTime);
      this.formList.formModel.visitTime = time;
    },
    async handleConfirm(ref, ConfirmOne) {
      // console.log(ref, "dededed");
      this.loading = true;
      this.formList.loading = true;
      // this.$refs[ref].validate((valid) => {
      //   console.log(valid);
      // });
      // 固定表单和动态表单都存在
      if (
        this.formList.dynamicValidateForm &&
        this.formList.dynamicValidateForm.dynamicItem.length !== 0 &&
        this.formList.formData
      ) {
        // 获取动态表单指向
        const dyRef = this.formList.dynamicValidateForm.ref;
        // 触发动态表单方法
        this.$refs[dyRef].$emit("ConfirmFunc", {
          ref: this.$refs[ref],
          loading: this.loading
        });
        this.loading = false;
        // 固定表单
      } else if (this.formList.formData || ConfirmOne) {
        this.$refs[ref].validate(valid => {
          if (valid) {
            this.$emit("handleClick", valid);
            this.loading = false;
            return true;
          } else {
            this.$emit("handleClick", valid);
            this.loading = false;
            return false;
          }
        });
        // 动态表单
      } else if (
        this.formList.dynamicValidateForm &&
        this.formList.dynamicValidateForm.dynamicItem.length !== 0 &&
        !this.formList.formData
      ) {
        console.log("dynamicItem");
        const dyRef = this.formList.dynamicValidateForm.ref;
        this.$refs[dyRef].$emit("ConfirmFunc", {
          loading: this.loading,
          ref: this.$refs[ref]
        });
        this.loading = false;
      }
    },
    handleCancel() {
      this.$emit("Cancel");
    },
    changeLoading(val) {
      this.loading = val;
    }
  }
};
</script>

<style>
.btn {
  background: #5691f2;
  color: #ffffff;
}
.form-container {
  position: relative;
}

.dialogBtn {
  /* position: absolute; */
  /* top: 0; */
  /* right: 0; */
  text-align: right;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Form/form.vue